// client/src/components/tendermaker/EditorPane.js
import React from "react";
import { EditorContent } from "@tiptap/react";
import EditorToolbar from "./EditorToolbar";
import PdfTextOverlay from "./PdfTextOverlay";

const btn = {
  padding: "5px 10px",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  background: "#fff",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: 11,
};
const btn2 = { ...btn, background: "#fafafa" };
const btnSave = { ...btn, background: "#2563eb", color: "#fff", borderColor: "#2563eb" };

export default function EditorPane({
  editor,
  activeItemId,
  docTitle,
  setDocTitle,
  profileDocs,
  onSaveDraft,
  onSaveDraftAsPdf,
  onInsertVaultImage,
  // PDF viewer in right pane
  editorPdfUrl,
  editorPdfKey,
  onSetEditorPdfUrl,
  activeItem,
  onSetErr,
}) {
  const showPdf = !!editorPdfUrl;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>

      {/* ========= PDF MODE ========= */}
      {showPdf && (
        <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", gap: 4 }}>
          <div style={{ display: "flex", gap: 6, alignItems: "center", flex: "0 0 auto" }}>
            <button style={btn} onClick={() => window.open(editorPdfUrl, "_blank")}>
              Open in Tab
            </button>
            <button style={btn} onClick={() => onSetEditorPdfUrl("")}>
              Back to Editor
            </button>
            <span style={{ fontSize: 10, color: "#9ca3af", marginLeft: "auto" }}>PDF Viewer</span>
          </div>
          <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            <PdfTextOverlay
              pdfUrl={editorPdfUrl}
              runId={activeItem?.runId || ""}
              activeItemId={activeItemId}
              activePdfKey={editorPdfKey}
              onSetErr={onSetErr}
              onPdfUpdated={(newUrl) => onSetEditorPdfUrl(newUrl)}
            />
          </div>
        </div>
      )}

      {/* ========= WORD EDITOR MODE ========= */}
      {!showPdf && (
        <>
          <div style={{ flex: "0 0 auto" }}>
            <EditorToolbar
              editor={editor}
              profileDocs={profileDocs}
              onInsertVaultImage={onInsertVaultImage}
            />
          </div>

          <div style={{ display: "flex", gap: 6, alignItems: "center", flex: "0 0 auto", marginTop: 4 }}>
            <input
              value={docTitle}
              onChange={(e) => setDocTitle(e.target.value)}
              placeholder="Document title"
              style={{ padding: "5px 8px", borderRadius: 8, border: "1px solid #e5e7eb", flex: 1, fontSize: 12, fontWeight: 600 }}
            />
            <button
              style={activeItemId ? btnSave : { ...btn, opacity: 0.5 }}
              disabled={!activeItemId}
              onClick={() => activeItemId && onSaveDraft(activeItemId)}
              title="Save draft (Ctrl+S)"
            >
              Save
            </button>
            {onSaveDraftAsPdf && activeItemId && (
              <button
                style={{ ...btn2 }}
                onClick={() => onSaveDraftAsPdf(activeItemId)}
                title="Render current draft as PDF and add to files"
              >
                Save as PDF
              </button>
            )}
          </div>

          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              padding: 12,
              flex: 1,
              minHeight: 0,
              overflow: "auto",
              background: "#fff",
              marginTop: 4,
            }}
          >
            <EditorContent editor={editor} />
          </div>

          <div style={{ display: "flex", gap: 12, alignItems: "center", fontSize: 10, color: "#9ca3af", flex: "0 0 auto", marginTop: 2 }}>
            {activeItemId ? (
              <span>
                Editing: <b style={{ color: "#374151" }}>{docTitle || activeItemId}</b> — Auto-saves every 15s
              </span>
            ) : (
              <span>Select a requirement chip to begin editing</span>
            )}
          </div>
        </>
      )}
    </div>
  );
}
